import { Token } from 'config/types'
import { DepositFiatPaymentMethod, WithdrawFiatPaymentMethod } from 'config/types/payment'
import Column from 'layout/Components/Column'
import { PaymentPageEnums } from 'views/Payment/Menu'
import { BankFormSelect } from './BankSelectDropdown'
import CurrencySelectDropdown from './CurrencySelectDropdown'

const PaymentBankCurrency = <T extends DepositFiatPaymentMethod | WithdrawFiatPaymentMethod>({
  selectedCurrency,
  selectedPaymentMethod,
  currencies,
  onPresentMethodSelect,
  disabled,
  onCurrencySelect,
  from,
}: {
  selectedCurrency: Token
  selectedPaymentMethod: T
  currencies: Token[]
  onPresentMethodSelect: () => void
  onCurrencySelect: (currency: Token) => void
  disabled?: boolean
  from: PaymentPageEnums
}) => {
  return (
    <Column gap="var(--pm-space-component, 20px)">
      <CurrencySelectDropdown
        hideHistory
        disabled={disabled}
        value={selectedCurrency}
        onTokenChange={onCurrencySelect}
        options={currencies}
        allCurrencies={currencies}
        from={from}
      />
      <BankFormSelect onPresentMethodSelect={onPresentMethodSelect} value={selectedPaymentMethod} />
    </Column>
  )
}

export default PaymentBankCurrency
